import type { ReactNode } from "react";
import { Box } from "@mui/material";
import { BAND_DOT } from "../partnerStatus";
import type { HealthBand } from "../partnerStatus";

interface StatusDotProps {
  band: HealthBand;
  children: ReactNode;
}

/**
 * Status = a band-coloured dot + a label (see `partnerStatus.ts`'s `BAND_DOT`
 * doc comment for the accessibility rationale). Shared by `PartnerMetricsTable`
 * and `PartnerMetricsTile` so the dot/label wrapper can't drift between the
 * two — each passes its own label content (plain text in the table, a
 * `Typography` in the tile), only the dot + layout are common.
 */
export function StatusDot({ band, children }: StatusDotProps) {
  return (
    <Box
      component="span"
      sx={{ display: "inline-flex", alignItems: "center", gap: 0.75, whiteSpace: "nowrap" }}
    >
      <Box
        component="span"
        aria-hidden
        sx={{ width: 8, height: 8, borderRadius: "50%", flexShrink: 0, bgcolor: BAND_DOT[band] }}
      />
      {children}
    </Box>
  );
}
